import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as amplitude from "@amplitude/analytics-browser";
import { useAuthContext } from "BEDROCK/auth/auth-provider";

// Centralized tracking wrapper that checks environment
const trackEvent = (
  eventName: string,
  eventProperties?: Record<string, any>
) => {
  // console.log("Tracking event:", eventName, eventProperties);
  const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";
  if (isProduction) {
    // console.log("--- successfully tracked event");
    amplitude.track(eventName, eventProperties);
  }
};

const setUserId = (userId: string) => {
  const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";
  if (isProduction) {
    amplitude.setUserId(userId);
  }
};

const resetUser = () => {
  const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";
  if (isProduction) {
    amplitude.reset();
  }
};

export function AnalyticsTracker() {
  const location = useLocation();
  const { userID, isUserAuthenticated } = useAuthContext();

  // Set user ID in Amplitude when user is authenticated
  useEffect(() => {
    if (isUserAuthenticated && userID) {
      setUserId(userID);
    } else {
      // Reset user ID when user is not authenticated
      resetUser();
    }
  }, [userID, isUserAuthenticated]);

  useEffect(() => {
    // Track specific route-based events
    const path = location.pathname;

    if (path.startsWith("/project/")) {
      trackEvent("Editor page viewed", {
        projectId: path.split("/")[2],
      });
    }

    if (path.startsWith("/checkout")) {
      if (path.startsWith("/checkout-confirmation")) {
        trackEvent("Checkout confirmation page viewed");
      } else {
        trackEvent("Checkout page viewed");
      }
    }

    if (path.startsWith("/collection-list")) {
      trackEvent("Template collection list page viewed");
    } else if (path.startsWith("/collection/")) {
      trackEvent("Template collection page viewed");
    }

    if (path.startsWith("/auth")) {
      trackEvent("Authentication page viewed");
    }
  }, [location]);

  return null;
}

export const useAnalyticsTracker = () => {
  return { trackEvent };
};
